"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.get = get;
exports.nullConfig = nullConfig;
exports.refreshConfig = refreshConfig;
var _objectHelpers = require("./utils/objectHelpers");
var _windowHelpers = require("./utils/windowHelpers");
/**
 * The config object
 */
var storedConfig = null;

/**
 * Get
 * Access the value for a supplied key
 * If a value cannot be determined null will be returned
 *
 * @param {string} key - The key corresponding to the value to be accessed
 * @returns {string} - The corresponding value for the supplied key
 */
function get(key) {
  // If config has not been loaded yet, load it
  if (!storedConfig) {
    storedConfig = (0, _windowHelpers.getGlobalConfig)();
  }

  // If there is no key, return everything
  if (!key) {
    return (0, _objectHelpers.deepClone)(storedConfig);
  }
  return (0, _objectHelpers.getValueAtKeypath)(storedConfig, key);
}

/**
 * Refresh Config
 * Reloads the current configutation values
 */
function refreshConfig() {
  storedConfig = (0, _windowHelpers.getGlobalConfig)();
}

/**
 * Null Config
 * Nulls out the value of storedConfig. For unit test use only.
 */
function nullConfig() {
  storedConfig = null;
}
var _default = exports["default"] = {
  get: get,
  refreshConfig: refreshConfig,
  nullConfig: nullConfig
};